export default __webpack_public_path__ + "77ea9f0.png";